<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-divider>{{ $T('餐饮预订') }}</el-divider>
      <div class="actions">
        <el-button type="primary" icon="el-icon-plus" @click="addMealRow">{{ $T('添加预约') }}</el-button>
        <el-button type="danger" plain icon="el-icon-delete" :disabled="mealList.length === 0" @click="clearAllMeals">{{ $T('清空全部') }}</el-button>
      </div>

      <el-table :data="mealList" border stripe size="mini" style="width:100%" :empty-text="$T('暂无餐饮预订，可点击添加或直接下一步清空')">
        <el-table-column :label="$T('场地')" min-width="200">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.venue_id"
              :placeholder="$T('请选择场地')"
              clearable
              style="width:100%"
              @change="onVenueChange(scope.row)"
            >
              <el-option v-for="venue in venueOptions" :key="venue.id" :label="venue.title" :value="venue.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="$T('套餐类型')" min-width="180">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.meal_set_id"
              :placeholder="$T('请选择套餐')"
              clearable
              style="width:100%"
              @change="onMealTypeChange(scope.row)"
            >
              <el-option v-for="mealSet in getMealSetByVenue(scope.row.venue_id)" :key="mealSet.id" :label="mealSet.name" :value="mealSet.id"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="$T('数量')" min-width="110">
          <template slot-scope="scope">
            <el-input style="width: 80px;" v-model.number="scope.row.quantity" type="number" min="1" @change="normalizeQuantity(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$T('价格')" min-width="100">
          <template slot-scope="scope">
            <span>{{ Number(scope.row.price || 0).toFixed(2) }} USD</span>
          </template>
        </el-table-column>
        <el-table-column :label="$T('小计')" min-width="110">
          <template slot-scope="scope">
            <span>{{ Number(rowSubtotal(scope.row)).toFixed(2) }} USD</span>
          </template>
        </el-table-column>
        <el-table-column :label="$T('状态')" min-width="100">
          <template slot-scope="scope">
            <span>{{ statusLabel(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$T('操作')" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" style="color:#f56c6c" @click="removeMealRow(scope.$index)">{{ $T('删除') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="summary">
        <span>{{ $T('总数量') }}: {{ totalQuantity }}</span>
        <span>{{ $T('总价') }}: {{ totalPrice.toFixed(2) }} USD</span>
      </div>

      <div class="footer-button">
        <el-button type="primary" :loading="saveLoading" @click="onNextStep">{{ $T('下一步') }}</el-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.actions {
  margin-bottom: 12px;
}
.summary {
  margin-top: 12px;
  font-size: 14px;
  color: #606266;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}
.footer-button {
  margin-top: 16px;
  text-align: center;
}
</style>

<script>
const createMealRow = () => ({
  venue_id: null,
  meal_set_id: null,
  quantity: 1,
  price: 0,
  status: 'Draft',
});

function normalizeMealRowFromApi(row) {
  const r = Object.assign({}, row);
  const vid = r.venue_id != null && r.venue_id !== '' ? Number(r.venue_id) : null;
  const mid = r.meal_set_id != null && r.meal_set_id !== '' ? Number(r.meal_set_id) : null;
  r.venue_id = vid && !Number.isNaN(vid) && vid > 0 ? vid : null;
  r.meal_set_id = mid && !Number.isNaN(mid) && mid > 0 ? mid : null;
  r.quantity = r.quantity != null && r.quantity !== '' ? Number(r.quantity) : 1;
  r.price = r.price != null ? Number(r.price) : 0;
  r.status = r.status || 'Draft';
  return r;
}

function hasVenue(row) {
  return row.venue_id != null && row.venue_id !== '' && Number(row.venue_id) > 0;
}

function hasMealSet(row) {
  return row.meal_set_id != null && row.meal_set_id !== '' && Number(row.meal_set_id) > 0;
}

function isBlankMealRow(row) {
  return !hasVenue(row) && !hasMealSet(row);
}

export default {
  name: 'SaiApplyFormStep4',
  data() {
    return {
      saveLoading: false,
      formData: {
        id: 0,
      },
      venueOptions: [],
      mealSetOptions: [],
      mealList: [],
    };
  },
  computed: {
    totalQuantity() {
      return this.mealList.reduce((total, row) => total + Number(row.quantity || 0), 0);
    },
    totalPrice() {
      return this.mealList.reduce((total, row) => total + Number(this.rowSubtotal(row) || 0), 0);
    },
  },
  mounted() {
    this.formData.id = this.$route.query.id;
    document.title = this.$T('餐饮预订');
    if (this.formData.id) {
      this.fetch();
    }
  },
  methods: {
    statusLabel(row) {
      const s = row.status;
      if (!s || s === 'Draft') {
        return this.$T('草稿');
      }
      return s;
    },
    fetch() {
      this.$api.post('/api/isai/step4detail', {
        id: this.formData.id,
      }, (res) => {
        const data = res.data || {};
        this.venueOptions = data.venue_options || [];
        this.mealSetOptions = data.meal_set_options || [];
        const reservationList = data.meal_reservation_list || [];
        if (reservationList.length > 0) {
          this.mealList = reservationList.map((row) => normalizeMealRowFromApi(row));
        } else {
          this.mealList = [];
        }
      }, (res) => {
        this.$message.error(res.msg || this.$T('加载失败'));
      });
    },
    getMealSetByVenue(venueId) {
      if (venueId == null || venueId === '') {
        return [];
      }
      return this.mealSetOptions.filter((item) => Number(item.venue_id) === Number(venueId));
    },
    onVenueChange(row) {
      row.meal_set_id = null;
      row.price = 0;
    },
    onMealTypeChange(row) {
      const selected = this.mealSetOptions.find((item) => Number(item.id) === Number(row.meal_set_id));
      row.price = selected ? Number(selected.price || 0) : 0;
    },
    normalizeQuantity(row) {
      const value = parseInt(row.quantity, 10);
      if (!value || value < 1) {
        row.quantity = 1;
        return;
      }
      if (value > 999) {
        row.quantity = 999;
        return;
      }
      row.quantity = value;
    },
    rowSubtotal(row) {
      return Number(row.quantity || 0) * Number(row.price || 0);
    },
    addMealRow() {
      this.mealList.push(createMealRow());
    },
    removeMealRow(index) {
      this.mealList.splice(index, 1);
    },
    clearAllMeals() {
      if (this.mealList.length === 0) {
        return;
      }
      this.$confirm(this.$T('确认清空全部餐饮预订？清空后需点下一步才会保存'), this.$T('确认'), {
        type: 'warning',
        confirmButtonText: this.$T('确认'),
        cancelButtonText: this.$T('取消'),
      }).then(() => {
        this.mealList = [];
      }).catch(() => {});
    },
    buildSavePayload() {
      return this.mealList
        .filter((row) => hasVenue(row) && hasMealSet(row))
        .map((row) => ({
          venue_id: Number(row.venue_id),
          meal_set_id: Number(row.meal_set_id),
          quantity: Number(row.quantity || 0),
        }));
    },
    saveMealList(payload) {
      this.saveLoading = true;
      this.$api.post('/api/isai/mealSave', {
        baoming_id: this.formData.id,
        meal_list: JSON.stringify(payload),
      }, () => {
        this.saveLoading = false;
        this.$message.success(payload.length === 0 ? this.$T('已取消全部餐饮预订') : this.$T('保存成功'));
        rbLink({
          name: 'ISaiApplyDetail',
          query: {
            id: this.formData.id,
          },
        }, 'back');
      }, (res) => {
        this.saveLoading = false;
        this.$message.error(res.msg || this.$T('保存失败'));
      });
    },
    onNextStep() {
      for (let i = 0; i < this.mealList.length; i++) {
        const row = this.mealList[i];
        if (isBlankMealRow(row)) {
          continue;
        }
        const n = i + 1;
        if (!hasVenue(row)) {
          this.$message.warning(this.$T('请选择场地') + ' (' + n + ')');
          return;
        }
        if (!hasMealSet(row)) {
          this.$message.warning(this.$T('请选择套餐') + ' (' + n + ')');
          return;
        }
      }

      const payload = this.buildSavePayload();
      if (payload.length === 0) {
        this.$confirm(this.$T('当前没有餐饮预订，确认取消全部餐饮预订并继续？'), this.$T('确认'), {
          type: 'warning',
          confirmButtonText: this.$T('确认'),
          cancelButtonText: this.$T('取消'),
        }).then(() => {
          this.saveMealList([]);
        }).catch(() => {});
        return;
      }

      this.saveMealList(payload);
    },
  },
};
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep4.vue?d2c318fa